import { useState, useEffect } from 'react';
import axios from 'axios';

export const PRICING_DEFAULTS = {
  discount_deadline: '2026-04-30',
  original_price: 3750,
  current_price: 1950,
};
let cachedSettings = null;

export function usePricingSettings() {
  const [settings, setSettings] = useState(cachedSettings || PRICING_DEFAULTS);

  useEffect(() => {
    if (cachedSettings) return;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/pricing/settings`)
      .then((res) => {
        if (res.data?.discount_deadline) {
          cachedSettings = { ...PRICING_DEFAULTS, ...res.data };
          setSettings(cachedSettings);
        }
      })
      .catch(() => {});
  }, []);

  return settings;
}

export function useDiscountDeadline() {
  return usePricingSettings().discount_deadline;
}

export function formatDeadline(deadline, language) {
  const date = new Date(`${deadline}T23:59:59`);
  return date.toLocaleDateString(language === 'nl' ? 'nl-BE' : 'en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatPrice(amount, language) {
  return `€${Number(amount).toLocaleString(language === 'nl' ? 'nl-NL' : 'en-US')}`;
}

export function isDiscountActive(deadline) {
  return new Date(`${deadline}T23:59:59`) > new Date();
}
